function showCookieBar() {
    const cookieAgreement = document.getElementById('cookie-agreement');
    if (cookieAgreement === null) {
        return;
    }

    cookieAgreement.style.display = 'block';
}

function hideCookieBar() {
    const cookieAgreement = document.getElementById('cookie-agreement');
    if (cookieAgreement === null) {
        return;
    }

    cookieAgreement.remove();
    document.dispatchEvent(new Event('headerBarClose'));
}

function showCookieModal() {
    const cookieModal = document.getElementById('cookie-modal');
    if (typeof cookieModal !== 'undefined' && cookieModal !== null) {
        cookieModal.style.display = 'block';
        cookieModal.style.opacity = '1';
    }
}

function hideCookieModal() {
    const cookieModal = document.getElementById('cookie-modal');
    if (typeof cookieModal !== 'undefined' && cookieModal !== null) {
        cookieModal.style.display = 'none';
        cookieModal.style.opacity = '0';
    }
}

function handleType() {
    if (window.Cookies.get('cookie-agreement') === '1') {
        return;
    }

    showCookieBar();
    const cookieModal = document.getElementById('cookie-modal');
    if (cookieModal !== null) {
        const type = parseInt(cookieModal.dataset.type.toString());
        if (type === 1) {
            window.Cookies.set('DisableAnalytics', 1, 60 * 24, '/');
            window.Cookies.set('DisableAllTracking', 1, 60 * 24, '/');
            window.Cookies.set('cookie-agreement', 0, 60 * 24, '/');
        } else {
            window.Cookies.set('DisableAnalytics', 0, 60 * 24, '/');
            window.Cookies.set('DisableAllTracking', 0, 60 * 24, '/');
            window.Cookies.set('cookie-agreement', 1, 60 * 24, '/');
        }
    }
}

function bindCookieModalExpandable() {
    const cookieModal = document.getElementById('cookie-modal');
    if (cookieModal !== null) {
        const expandButtons = document.getElementsByClassName('expand-button');
        if (expandButtons.length > 0) {
            for (const expandBtn of expandButtons) {
                expandBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    document.dispatchEvent(new Event('headerBarClose'));
                    expandBtn.classList.add('d-none');
                    if (expandBtn.previousElementSibling !== null) {
                        expandBtn.previousElementSibling.classList.add('open');
                    }
                    if (expandBtn.nextElementSibling !== null && !expandBtn.nextElementSibling.classList.contains('visible')) {
                        expandBtn.nextElementSibling.classList.add('visible');
                    }
                });
            }
        }

        const collapseButtons = document.getElementsByClassName('collapse-button');
        if (collapseButtons.length > 0) {
            for (const collapsedBtn of collapseButtons) {
                collapsedBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    document.dispatchEvent(new Event('headerBarClose'));
                    if (collapsedBtn.classList.contains('visible')) {
                        collapsedBtn.classList.remove('visible');
                    }

                    if (
                        collapsedBtn.previousElementSibling !== null
                        && collapsedBtn.previousElementSibling.classList.contains('d-none')
                    ) {
                        collapsedBtn.previousElementSibling.classList.remove('d-none');
                    }

                    if (
                        collapsedBtn.previousElementSibling !== null
                        && collapsedBtn.previousElementSibling.previousElementSibling !== null
                        && collapsedBtn.previousElementSibling.previousElementSibling.classList.contains('open')
                    ) {
                        collapsedBtn.previousElementSibling.previousElementSibling.classList.remove('open');
                    }
                });
            }
        }
    }
}

function bindConfirmAll() {
    const confirmAllBtn = document.getElementById('cookie-bar-confirm-all');
    if (confirmAllBtn !== null) {
        confirmAllBtn.addEventListener('click', (e) => {
            e.preventDefault();
            hideCookieBar();
            hideCookieModal();
            window.Cookies.set("DisableAnalytics", 0, 60 * 24);
            window.Cookies.set("DisableAllTracking", 0, 60 * 24);
            window.Cookies.set("cookie-agreement", 1, 60 * 24);
        });
    }
}

function bindConfirmAllModal() {
    const confirmAllModalBtn = document.getElementById('cookie-modal-confirm-all');
    if (confirmAllModalBtn !== null) {
        confirmAllModalBtn.addEventListener('click', (e) => {
            hideCookieBar();
            hideCookieModal();
            setCookieModalCheckbox('technical-cookies', true);
            setCookieModalCheckbox('analytical-cookies', true);
            setCookieModalCheckbox('marketing-cookies', true);
            window.Cookies.set("DisableAnalytics", 0, 60 * 24);
            window.Cookies.set("DisableAllTracking", 0, 60 * 24);
            window.Cookies.set("cookie-agreement", 1, 60 * 24);
        });
    }
}

function bindPrivacyAgreement() {
    const privacyAgreementBtn = document.getElementById('cookie-bar-privacy-agreement');
    if (privacyAgreementBtn !== null) {
        privacyAgreementBtn.addEventListener('click', (e) => {
            window.Cookies.set("DisableAnalytics", 0, 60 * 24);
            window.Cookies.set("DisableAllTracking", 0, 60 * 24);
            window.Cookies.set("cookie-agreement", 0, 60 * 24);
        });
    }
}

function setCookieModalCheckbox(id, value) {
    const checkbox = document.getElementById(id);
    if (checkbox !== null) {
        checkbox.checked = value;
    }
}

function bindModalSingleSelectionButton() {
    const cookieModalSingleSelectionBtn = document.getElementById('cookie-modal-confirm-single-selection');
    if (cookieModalSingleSelectionBtn !== null) {
        cookieModalSingleSelectionBtn.addEventListener('click', (e) => {
            const technicalCookiesInput = document.getElementById('technical-cookies');
            const analyticalCookiesInput = document.getElementById('analytical-cookies');
            const marketingCookiesInput = document.getElementById('marketing-cookies');
            if (!technicalCookiesInput.checked) {
                e.preventDefault();
                cookieModalSingleSelectionBtn.setAttribute('disabled', 'disabled');
                const err = document.getElementById('technical-cookies-error-message');
                if (err !== null) {
                    err.style.display = 'block';
                }
                return;
            }

            hideCookieBar();
            hideCookieModal();
            window.Cookies.set("DisableAnalytics", analyticalCookiesInput.checked ? 0 : 1, 60 * 24);
            window.Cookies.set("DisableAllTracking", marketingCookiesInput.checked ? 0 : 1, 60 * 24);
            window.Cookies.set("cookie-agreement", technicalCookiesInput ? 1 : 0, 60 * 24);
        });
    }
}

function bindModalTechnicalCheckbox() {
    const technicalCookiesInput = document.getElementById('technical-cookies');
    if (technicalCookiesInput !== null) {
        technicalCookiesInput.addEventListener('click', (e) => {
            if (technicalCookiesInput.checked) {
                const cookieModalSingleSelectionBtn = document.getElementById('cookie-modal-confirm-single-selection');
                if (cookieModalSingleSelectionBtn !== null) {
                    cookieModalSingleSelectionBtn.removeAttribute('disabled');
                }

                const err = document.getElementById('technical-cookies-error-message');
                if (err !== null) {
                    err.style.display = 'none';
                }
            } else {
                const err = document.getElementById('technical-cookies-error-message');
                if (err !== null) {
                    err.style.display = 'block';
                }
            }
        });
    }
}

function initCookieModalCheckboxes() {
    setCookieModalCheckbox('technical-cookies', window.Cookies.get('cookie-agreement') === '1');
    setCookieModalCheckbox('analytical-cookies', window.Cookies.get('DisableAnalytics') === '0');
    setCookieModalCheckbox('marketing-cookies', window.Cookies.get('DisableAllTracking') === '0');
}

document.addEventListener('DOMContentLoaded', () => {
    bindCookieModalExpandable();
    bindConfirmAll();
    bindConfirmAllModal();
    bindPrivacyAgreement();
    bindModalSingleSelectionButton();
    bindModalTechnicalCheckbox();

    const cookieBarSingleSelection = document.getElementById('cookie-bar-single-selection');
    if (cookieBarSingleSelection !== null) {
        cookieBarSingleSelection.addEventListener('click', (e) => {
            e.preventDefault();
            hideCookieBar();
            showCookieModal();
            return false;
        });
    }
    handleType();
    initCookieModalCheckboxes();

    for (const el of document.querySelectorAll('[href="#cookie-modal"]')) {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            showCookieModal();
        });
    }
});
